import React, { useEffect, useState } from "react";
import { Share, Plus, X } from "lucide-react";
import { isIOS, isStandalone } from "../lib/push";

const DISMISS_KEY = "sporty:ios-install-dismissed-at";
// Re-show 7 days after the user dismisses, so we're persistent but not abusive.
const REAPPEAR_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export default function IosInstallBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        // Only iOS Safari (not Android, not Chrome, not when already installed).
        if (!isIOS() || isStandalone()) return;
        const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
        if (dismissedAt && Date.now() - dismissedAt < REAPPEAR_AFTER_MS) return;
        setShow(true);
    }, []);

    if (!show) return null;

    const dismiss = () => {
        try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (err) {
            console.warn("[ios-banner] could not persist dismiss:", err);
        }
        setShow(false);
    };

    return (
        <div
            className="md:hidden fixed left-0 right-0 z-40 px-3 pt-2"
            style={{ top: "calc(env(safe-area-inset-top, 0px) + 3rem)" }}
            data-testid="ios-install-banner"
        >
            <div className="relative border border-[#FF3B30]/40 bg-[#1A0808]/95 backdrop-blur-sm p-3" style={{ borderRadius: 2 }}>
                <button
                    onClick={dismiss}
                    aria-label="Dismiss"
                    className="absolute top-2 right-2 text-zinc-500 hover:text-white"
                    data-testid="ios-install-dismiss"
                >
                    <X size={16} />
                </button>
                <div className="flex items-start gap-3 pr-6">
                    <div className="w-8 h-8 bg-[#FF3B30] flex items-center justify-center flex-shrink-0" style={{ borderRadius: 2 }}>
                        <span className="heading text-base font-black text-white">S</span>
                    </div>
                    <div className="min-w-0">
                        <div className="heading text-base uppercase font-black tracking-tight leading-tight">
                            Install Nerdy
                        </div>
                        <div className="text-xs text-zinc-300 mt-1 leading-snug">
                            Tap <Share size={12} className="inline mx-0.5 -mt-0.5 text-[#5EC9FF]" /> in Safari,
                            then <span className="inline-flex items-center gap-0.5 px-1 py-0.5 border border-white/15 mx-0.5" style={{ borderRadius: 2 }}><Plus size={10} /> <span className="text-[10px] font-bold">Add to Home Screen</span></span>
                            for notifications & a faster app.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
